export const REMOVE_APPROVER_REQUEST = "REMOVE_APPROVER_REQUEST";
export const REMOVE_APPROVER_SUCCESS = "REMOVE_APPROVER_SUCCESS";
export const REMOVE_APPROVER_FAILURE = "REMOVE_APPROVER_FAILURE";
export const REMOVE_APPROVER_RESET = "REMOVE_APPROVER_RESET";
export const removeApproverRequest = (payload) => ({
    type: REMOVE_APPROVER_REQUEST,
    payload,
});
export const removeApproverSuccess = (payload) => ({
    type: REMOVE_APPROVER_SUCCESS,
    payload,
});
export const removeApproverFailure = (payload) => ({
    type: REMOVE_APPROVER_FAILURE,
    payload,
});
export const removeApproverReset = () => ({
    type: REMOVE_APPROVER_RESET,
});
